// Donations dated after July 31, 2026 can no longer be added or submitted,
// except for Metro retail stores, which are exempt from this cutoff entirely.
const CUTOFF_YEAR = 2026;
const CUTOFF_MONTH_INDEX = 6; // July (0-indexed Date month)
const CUTOFF_DAY = 31;

export const METRO_RETAILER_NAME = 'Metro One More Bite';

const CUTOFF_DATE = new Date(CUTOFF_YEAR, CUTOFF_MONTH_INDEX, CUTOFF_DAY, 23, 59, 59, 999);

export function isRetailerExempt(retailerName?: string | null): boolean {
    return retailerName === METRO_RETAILER_NAME;
}

export function isDateAfterCutoff(date: Date): boolean {
    return date.getTime() > CUTOFF_DATE.getTime();
}

// Determines whether a donation with the given date/retailer is blocked by the cutoff.
// Metro retail stores are exempt and can report for any date.
export function isDonationBlocked(date: Date, retailerName?: string | null): boolean {
    console.log('block check?', date, retailerName);
    if (isRetailerExempt(retailerName)) {
        return false;
    }
    return isDateAfterCutoff(date);
}
